module.exports = __webpack_public_path__ + "img/electric_reserved.65f24147.svg";